import React, { useContext, useEffect, useState } from "react";
import style from "./Thechat.module.css"
import {BsPersonFillAdd} from "react-icons/bs"
import {AiOutlineUserAdd} from "react-icons/ai"
import Message from "../chat/Message"
import Sendinput from "../chat/Sendinput";
import { Chatcontext } from "../context/Chatcontext";
import { collection, doc, getDoc, getDocs, onSnapshot, query, updateDoc, where } from "firebase/firestore";
import { db } from "../../firebase/config";
import Overlay from "./Overlay";
import Chatcard from "./Chatcard";
import {TiUserDelete} from "react-icons/ti"
import "react-toastify/dist/ReactToastify.css"
import {ToastContainer, toast} from"react-toastify"
import Addchat from "./Addchat";
import { getMessaging } from "firebase/messaging";
const Thechat=()=>{
    const chatcontext=useContext(Chatcontext);
    const [chat , setChat] = useState([]);
    const [chatusers,setChatusers]=useState([]);
    const [users , setUsers] = useState([])
    const [overlay,setOverlay]=useState(false);
    const [overlaydelete,setOverlaydelete]=useState(false);
    const [filteredusers,setFilterduser]=useState([]);
    const [enddate,setEnddate]=useState("")
    const today = new Date();
    const [engneers,setEngineers]=useState([]);
    const [clients,setClients]=useState([]);
    const [supervisor,setSupervisor]=useState([]);
    const [support,setSupport]=useState([]);
    const [admin,setAdmin]=useState([]);
    const [filteredengneers,setFilterdengneers]=useState([]);
    const [filteredclients,setFilterdclients]=useState([]);
    const [filteredsupervisor,setFilterdsupervisor]=useState([]);
    const [filteredsupport,setFilterdsupport]=useState([]);
    const [filteredadmin,setFilterdadmin]=useState([]);
    const [chatname,setChatname]=useState("")
    useEffect(()=>{
        const q = query(collection(db, "users"), where("rule", "==", "client" ));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const demo = [];
            querySnapshot.forEach((doc) => {
                demo.push(doc.data());
            });
            setClients(demo);
        });
        const qq = query(collection(db, "users"), where("rule", "==", "engineer"));
        const unnsubscribe = onSnapshot(qq, (querySnapshot) => {
            const demo = [];
            querySnapshot.forEach((doc) => {
                demo.push(doc.data());
            });
            setEngineers(demo);
        });
        const qqq = query(collection(db, "users"), where("rule", "==", "supervisor"));
        const unnnsubscribe = onSnapshot(qqq, (querySnapshot) => {
            const demo = [];
            querySnapshot.forEach((doc) => {
                demo.push(doc.data());
            });
            setSupervisor(demo);
        });
        const qqqq = query(collection(db, "users"), where("rule", "==", "support"));
        const unnnnsubscribe = onSnapshot(qqqq, (querySnapshot) => {
            const demo = [];
            querySnapshot.forEach((doc) => {
                demo.push(doc.data());
            });
            setSupport(demo);
        });
        const qqqqq = query(collection(db, "users"), where("rule", "==", "admin"));
        const unnnnnsubscribe = onSnapshot(qqqqq, (querySnapshot) => {
            const demo = [];
            querySnapshot.forEach((doc) => {
                demo.push(doc.data());
            });
            setAdmin(demo);
        });

    },[])
    const getAdminsUsers=()=>{
        const qqqqq = query(collection(db, "users"), where("rule", "==", "admin"));
        const unnnnnsubscribe = onSnapshot(qqqqq, (querySnapshot) => {
            const demo = [];
            querySnapshot.forEach((doc) => {
                demo.push(doc.data());
            });
            setAdmin(demo);
        });
    }
    // .........................................................................................
    const subscribeToTopic = ( topic) => {
        // Replace 'your-topic' with the desired topic name
        fetch('https://iid.googleapis.com/iid/v1/'+"dCqDMNy4wwp7NVNz7WyH3W:APA91bE4sfb4ohEy_CLTQGu1_QXSipbnWt5oMJ9f3zjrYZSnPZXPLGtavZNXXLzJ-SoZVxU6n2AtG5Q1gMH9i2VGI_EsPBCbnjVb-s9bXoqUGkshdPQpGAfw6cQHmZMYmUJmhdU44MKI"+'/rel/topics/'+topic, {
            method: 'POST',
            headers: new Headers({
              'Authorization': 'key='+"AAAAs-3yQWM:APA91bF4cvC8CEZGJBTCSLUpKcAGW4bMFfyQjyC3xjvtf8ISQU-njRJsAHGx_ItlrYhY1pxZQOb3ZmN0nyXTS91fLFbB1rhn5JkPorQ9QgCCCm0nqXosMrFaX_zFLAB6JcgafBX4FOYN"
            })
          }).then(response => {
            if (response.status < 200 || response.status >= 400) {
              throw 'Error subscribing to topic: '+response.status + ' - ' + response.text();
            }
          }).catch(error => {
            console.error(error);
          })
      };
    useEffect(()=>{
        subscribeToTopic(chatcontext.chatid);
        const unsub = onSnapshot(doc(db, "messages", chatcontext.chatid), (doc) => {
            doc.exists() && setChat(doc.data())
        });
        const getchatuser=async()=>{
            const docRef = doc(db, "roomuser", chatcontext.chatid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                setChatusers(docSnap.data().users)
                setEnddate(docSnap.data().enddate)
                setChatname(docSnap.data().name)
            } else {
                console.log("No such document!");
            }
        }
        getchatuser()
        const getallusers=async()=>{
            const querySnapshot = await getDocs(collection(db, "users"));
            const demo = [];
            querySnapshot.forEach((doc) => {
                demo.push(doc.data());
            });
            setUsers(demo);
        }
        getallusers()

    },[chatcontext.chatid,enddate])
    useEffect(()=>{
        const calculatedays=()=>{
            const theenddate=new Date(enddate);
            const time = Math.abs(theenddate-today);
            const days= Math.ceil(time/(1000*60*60*24));
            if(days<=6){
                toast.error(`يتبقي علي معاد انتهاء المشروع ${days}`)
            }
        }
        calculatedays();
    },[enddate])
    const showoverlay=()=>{
        setFilterdengneers(engneers.filter(user=>!chatusers.includes(user.uid)));
        setFilterdclients(clients.filter(user=>!chatusers.includes(user.uid)));
        setFilterdsupervisor(supervisor.filter(user=>!chatusers.includes(user.uid)));
        setFilterdsupport(support.filter(user=>!chatusers.includes(user.uid)));
        setFilterdadmin(admin.filter(user=>!chatusers.includes(user.uid)));
        setOverlay(true)
    }
    const showoverlaydel=()=>{
        setFilterduser(users.filter(user => chatusers.some(item => item.user_id === user.uid)));
        setOverlaydelete(true)
    }
    const demo=[];
    const addtochat = (user) => {
        // Check if the user already exists in userArray
        const userIndex = chatusers.findIndex((item) => item.user_id === user.uid);
      
        if (userIndex !== -1) {
          // If the user exists, remove them from userArray
          const updatedUserArray = [...chatusers];
          updatedUserArray.splice(userIndex, 1);
          setChatusers(updatedUserArray);
        } else {
          // If the user doesn't exist, add them to the userArray with un_read_message set to 0
          setChatusers([...chatusers, { user_id: user.uid, un_read_message: 0 }]);
        }
      };
    const deletechat=(user) => {
        // Check if the user already exists in userArray
        const userIndex = chatusers.findIndex((item) => item.user_id === user.uid);
      
        if (userIndex !== -1) {
          // If the user exists, remove them from userArray
          const updatedUserArray = [...chatusers];
          updatedUserArray.splice(userIndex, 1);
          setChatusers(updatedUserArray);
        } else {
          // If the user doesn't exist, add them to the userArray with un_read_message set to 0
          setChatusers([...chatusers, { user_id: user.uid, un_read_message: 0 }]);
        }
      };
    const updatechat=()=>{
        updateDoc(doc(db,"roomuser",chatcontext.chatid),{
            users:chatusers,
        })
        setOverlaydelete(false)
        setOverlay(false)
    }
    return(
        <div className={style.messagescontainer}>
            <ToastContainer/>
            {overlay&&
                <Overlay>
                    <div className={style.adduser}>
                        <div className={style.addusernav}>
                            <AiOutlineUserAdd size={50}/>
                        </div>
                        <div className={style.users}>
                            <h2>العملاء</h2>
                            <div className={style.engineer}>
                                {filteredclients.map((client)=>{
                                    return(
                                        <Chatcard key={client.uid} addtochat={addtochat} userarray={chatusers} client={client}/>
                                    )
                                })}
                            </div>
                            <hr/>
                            <h2>المهندسين</h2>
                            <div className={style.engineer}>
                                {filteredengneers.map((engneer)=>{
                                    return(
                                        <Chatcard key={engneer.uid} addtochat={addtochat} userarray={chatusers} client={engneer}/>
                                    )
                                })}
                            </div>
                            <hr/>
                            <h2>المشرفين</h2>
                            <div className={style.engineer}>
                                {filteredsupervisor.map((engneer)=>{
                                    return(
                                        <Chatcard key={engneer.uid} addtochat={addtochat} userarray={chatusers} client={engneer}/>
                                    )
                                })}
                            </div>
                            <hr/>
                            <h2>الدعم الفني</h2>
                            <div className={style.engineer}>
                                {filteredsupport.map((engneer)=>{
                                    return(
                                        <Chatcard key={engneer.uid} addtochat={addtochat} userarray={chatusers} client={engneer}/>
                                    )
                                })}
                            </div>
                            <hr/>
                            <h2>الادمن</h2>
                            <div className={style.engineer}>
                                {filteredadmin.map((engneer)=>{
                                    return(
                                        <Chatcard key={engneer.uid} addtochat={addtochat} userarray={chatusers} client={engneer}/>
                                    )
                                })}
                            </div>
                        </div>
                        <div className={style.adduserbutton}>
                            <button onClick={updatechat}>اضافه</button>
                            <button onClick={()=>setOverlay(false)}>الغاء</button>
                        </div>
                    </div>
                </Overlay>
            }
            {overlaydelete&&
                <Overlay>
                    <div className={style.adduser}>
                        <div className={style.addusernav}>
                            <TiUserDelete size={50}/>
                        </div>
                        <div className={style.users}>
                            {filteredusers.map((client)=>{
                                return(
                                    <Chatcard  key={client.uid} addtochat={deletechat} userarray={chatusers}  client={client}/>
                                )
                            })}
                        </div>
                        <div className={style.adduserbutton}>
                            <button onClick={updatechat}>ازاله</button>
                            <button onClick={()=>setOverlaydelete(false)}>الغاء</button>
                        </div>
                    </div>
                </Overlay>
            }
            <div className={style.messagesnav}>
                <p>{chatname}</p>
                <div className={style.messageicon}>
                    <BsPersonFillAdd style={{cursor:"pointer"}} size={40} onClick={showoverlay}/>
                    <TiUserDelete style={{cursor:"pointer" , marginRight:"20px"}} size={40} onClick={showoverlaydel}/>
                </div>
            </div>
            <div className={style.message}>
                {chat.message && chat.message.map((m)=>{
                    return <Message color="white" key={m.id} message={m}/>
                })}
            </div>
            <Sendinput bordercolor="1px solid #D3A61E" color="black"/>
        </div>
    )
}
export default Thechat;